import React from "react"

import BaseSvgIcon from "../Base"

const AiStarGradient = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <g clipPath="url(#clip0_11287_6880)">
        <path
          d="M2.33815 4.39043C2.31195 4.04203 2.03646 3.76836 1.69015 3.74119C0.823898 3.67423 0.82293 2.40196 1.68919 2.3379C2.03647 2.31267 2.31099 2.03609 2.33815 1.68964C2.40508 0.823013 3.67682 0.822045 3.74181 1.68769C3.768 2.03609 4.0435 2.30976 4.3898 2.33693C5.25606 2.40389 5.25703 3.67616 4.39077 3.74022C4.0435 3.76545 3.76897 4.04203 3.74181 4.38848C3.67487 5.25511 2.40314 5.25608 2.33815 4.39043Z"
          fill="url(#paint0_linear_11287_6880)"
        />
        <path
          d="M12.96 11.76C12.2973 11.76 11.76 12.2973 11.76 12.96C11.76 13.6227 12.2973 14.16 12.96 14.16C13.6227 14.16 14.16 13.6227 14.16 12.96C14.16 12.2973 13.6227 11.76 12.96 11.76Z"
          fill="url(#paint1_linear_11287_6880)"
        />
        <path
          d="M7.43509 15.4666L7.36806 14.3076C7.19139 11.2494 4.75091 8.80896 1.69243 8.63192L0.533379 8.56488C-0.177793 8.52368 -0.177793 7.47599 0.533379 7.43509L1.69243 7.36806C4.75057 7.19139 7.19104 4.75091 7.36806 1.69243L7.43508 0.533379C7.47633 -0.177793 8.524 -0.177793 8.56488 0.533379L8.63192 1.69243C8.80864 4.75057 11.2491 7.19104 14.3076 7.36806L15.4666 7.43508C16.1778 7.47633 16.1778 8.524 15.4666 8.56488L14.3076 8.63192C11.2494 8.80864 8.80896 11.2491 8.63192 14.3076L8.56488 15.4666C8.52368 16.1778 7.47599 16.1778 7.43509 15.4666Z"
          fill="url(#paint2_linear_11287_6880)"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_11287_6880" x1="1.04004" y1="3.03906" x2="5.04004" y2="3.03906" gradientUnits="userSpaceOnUse">
          <stop stopColor="#050833" />
          <stop offset="1" stopColor="#712AF8" />
        </linearGradient>
        <linearGradient id="paint1_linear_11287_6880" x1="14.1602" y1="12.96" x2="11.7602" y2="12.96" gradientUnits="userSpaceOnUse">
          <stop stopColor="#050833" />
          <stop offset="1" stopColor="#712AF8" />
        </linearGradient>
        <linearGradient id="paint2_linear_11287_6880" x1="0" y1="8" x2="16" y2="8" gradientUnits="userSpaceOnUse">
          <stop stopColor="#050833" />
          <stop offset="1" stopColor="#712AF8" />
        </linearGradient>
        <clipPath id="clip0_11287_6880">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default AiStarGradient
